import { useAppSelector } from '../..'
import { type IUser } from '../../../models/User'

export const getUserProfileLoading = (): boolean => useAppSelector((state) => state.user.loading)
export const getUserProfileError = (): boolean => useAppSelector((state) => state.user.error)
export const getUserProfile = (): IUser => useAppSelector((state) => state.user.user ?? '')
